import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useState } from 'react';

import type { AudienceType } from '@/api/audience';
import { WizardDialog } from '@/components/wizard';

import AudienceActivationConsentStep from './AudienceActivationConsentStep';
import AudienceActivationSelectVendorStep from './AudienceActivationSelectVendorStep';

type Props<T> = {
  audience: AudienceType | undefined;
  onClose: () => void;
  onComplete: ((data: T) => void) | undefined;
};

const AudienceActivationModal = <T extends Record<string, unknown>>({
  audience,
  onClose,
  onComplete,
}: Props<T>) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleComplete = async (data: T) => {
    setIsLoading(true);
    await onComplete?.(data);
    setIsLoading(false);
  };

  return (
    <WizardDialog
      open={audience != null}
      isLoading={isLoading}
      onCancel={onClose}
      onComplete={handleComplete}
      steps={[
        {
          id: 'provider-type',
          title: <Trans>Choose a vendor</Trans>,
          component: audience && <AudienceActivationSelectVendorStep audience={audience} />,
        },
        {
          id: 'review-consent',
          title: <Trans>Please ensure consent</Trans>,
          component: <AudienceActivationConsentStep />,
          nextButtonText: t`Activate`,
        },
      ]}
    />
  );
};

export default AudienceActivationModal;
